import React from "react";
import StateControl from "./StateControl";

function App() {
  return (
    <StateControl/>
  );
}

export default App;